import React from 'react';

interface TooltipPayloadItem {
	payload: {
		status: string;
		count: number;
		color: string;
	};
	value: number;
	name: string;
}

interface TooltipProps {
	active?: boolean;
	payload?: TooltipPayloadItem[];
}

const CustomTooltip: React.FC<TooltipProps> = ({ active, payload }) => {
	if (!active || !payload || !payload.length) return null;

	return (
		<div
			style={{
				backgroundColor: '#fff',
				padding: '10px',
				border: '1px solid #ccc',
				borderRadius: '4px',
			}}
		>
			<p style={{ margin: 0 }}>{`${payload[0].payload.status}: ${payload[0].value}`}</p>
		</div>
	);
};

export default CustomTooltip;
